import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

// azure
import { BrowserUtils } from "@azure/msal-browser";

import { SLUG_LOW_FLOW } from "./routes";
import { AuthGuard } from "./core/guards/auth.guard";
import { MustBeActivatedDashboard } from "./flow/core/guards/mustBeActivatedDashboard.guard";

const routes: Routes = [
	{
		path: SLUG_LOW_FLOW,
		canActivate: [AuthGuard],
		loadChildren: () =>
			import("./flow/flow.module").then((m) => m.FlowModule),
	},
	{
		path: "dashboard/:slug",
		canActivate: [AuthGuard, MustBeActivatedDashboard],
		loadChildren: () =>
			import("./flow/features/dashboard-flow/dashboard-flow.module").then((m) => m.DashboardFlowModule),
	},
	{
		path: "",
		loadChildren: () =>
			import("./home/home.module").then((m) => m.HomeModule),
	},
	{
		path: "",
		redirectTo: "",
		pathMatch: "full",
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			relativeLinkResolution: "legacy",
			initialNavigation:
				!BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
					? "enabled"
					: "disabled",
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
